/**
 * Google sign-in endpoints — thin wrappers around the FastAPI backend.
 *
 * The OAuth dance itself is browser-driven (full-page redirect to
 * Google and back). The SPA only talks to three of the five endpoints
 * directly: ``POST /auth/google/exchange`` to redeem the one-time code
 * after Google's redirect lands, plus the ``GET`` and ``DELETE`` of
 * ``/auth/google/link`` for the settings page. ``/start`` and
 * ``/callback`` are reached via ``<a href>`` and Google's redirect
 * respectively, so they are not modeled here.
 */

import { ApiClient } from "./client";
import type { AuthResponse } from "./auth";

export interface GoogleLinkStatus {
  linked: boolean;
  email: string | null;
  linked_at: string | null;
}

export const googleApi = (client: ApiClient) => ({
  exchange(exchangeCode: string): Promise<AuthResponse> {
    return client.request<AuthResponse>("/auth/google/exchange", {
      method: "POST",
      json: { exchange_code: exchangeCode },
    });
  },

  linkStatus(): Promise<GoogleLinkStatus> {
    return client.request<GoogleLinkStatus>("/auth/google/link", {
      method: "GET",
    });
  },

  unlink(): Promise<void> {
    return client.request<void>("/auth/google/link", {
      method: "DELETE",
    });
  },
});
